import Vue from "vue";
import Vuex from "vuex";

import systemInfo from "./modules/systemInfo";
import auth from "./modules/auth";
import cookie from "./modules/cookie";
import toplist from "./modules/toplist";
import programs from "./modules/programs";
import campaigns from "./modules/campaigns";
import channels from "./modules/channels";
import streaming from "./modules/streaming";

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    systemInfo,
    auth,
    cookie,
    toplist,
    programs,
    campaigns,
    channels,
    streaming
  }
});
